import  React from "react";
import {Col, Container, Row} from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TableData from "../../components/tables";

import { requestPatients, searchPatients } from "../../actions/patients.action";
import moment from "moment";

class Patients extends React.Component {

    constructor(props) {
        super(props);
        this.props.loadData();
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle title="Patients" subtitle="Patients" className="text-sm-left mb-3"/>
                </Row>
                <Row>
                    <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                        {this.props.patients.fetching ? (
                            <div className="flex-center">
                                <div className="text-center d-block">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <TableData
                                research={this.props.patients.searching}
                                tableData="patients"
                                dataColumns={[
                                  {
                                    Header: "Prénom",
                                    accessor: "firstname",
                                    className: "text-center",
                                    Cell: row => (
                                      <Link to={'/patients/' + row.original.id + '/profil'}>
                                        <div
                                          className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                        />
                                        <span className="table__filter__practitioner">{row.original.first_name}</span>
                                      </Link>
                                    ),
                                  }, {
                                    Header: "Nom",
                                    accessor: "lastname",
                                    className: "text-center",
                                    Cell: row => (
                                      <Link to={'/patients/' + row.original.id + '/profil'}>
                                        <div
                                          className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                        />
                                        <span className="table__filter__practitioner">{row.original.last_name}</span>
                                      </Link>
                                    ),
                                  },
                                  {
                                    Header: "Email",
                                    accessor: "email",
                                    className: "text-center",
                                    Cell: row => (
                                      <Link to={'/patients/' + row.original.id + '/profil'}>
                                        <div
                                          className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                        />
                                        <span className="table__filter__practitioner"
                                              title={row.original.email}>{row.original.email}</span>
                                      </Link>
                                    ),
                                  },
                                    {
                                        Header: "Parent",
                                        accessor: "parent",
                                        className: "text-center",
                                        Cell: row => (
                                            <div>
                                                {row.original.parent &&
                                                    <Link to={'/patients/' + row.original.parent.id + '/profil'}>
                                                        <span className="table__filter__practitioner">
                                                            {row.original.parent.email}
                                                        </span>
                                                    </Link>
                                                }
                                            </div>
                                        )
                                    },
                                  {
                                    Header: "Téléphone",
                                    accessor: "phone",
                                    className: "text-center",
                                    Cell: row => (
                                      <Link to={'/patients/' + row.original.id + '/profil'}>
                                        <div
                                          className="d-inline-block item-icon-wrapper table__filter__practitioner"
                                        />
                                        <span className="table__filter__practitioner"
                                              title={row.original.phone}>{row.original.phone}</span>
                                      </Link>
                                    ),
                                  },
                                    {
                                        Header: "Dernière connexion",
                                        accessor: "updated_at",
                                        maxWidth: 150,
                                        className: "text-center",
                                        Cell: row => (
                                            <span className="table__filter__practitioner">{ row.original.updated_at ? ( moment(row.original.updated_at).format("DD/MM/YYYY") ) : ( 'Date Invalide' ) }</span>
                                        )
                                    },
                                    {
                                        Header: "Date de création",
                                        accessor: "created_at",
                                        maxWidth: 150,
                                        className: "text-center",
                                        Cell: row => (
                                            <span className="table__filter__practitioner">{ row.original.created_at ? ( moment(row.original.created_at).format("DD/MM/YYYY") ) : ( 'Date Invalide' ) }</span>
                                        )
                                    },
                                    {
                                        Header: "Statut",
                                        accessor: "premium",
                                        maxWidth: 150,
                                        className: "text-center",
                                        Cell: row => (
                                            <span className="table__filter__practitioner">{row.original.premium ? "premium" : "standard"}</span>
                                        )
                                    }
                                ]}
                                pageSize={20}
                                title={"Liste des patients"}
                                dataSearch={searchPatients}
                                dataName={'patients'}
                            />
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        patients: state['patients'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: () => dispatch(requestPatients()),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Patients);



// WEBPACK FOOTER //
// ./src/views/Patients/Patients.js